(() => {
  function init(scope = document) {
    scope.querySelectorAll('.sweet-shop__nav').forEach(nav => {
      if (nav.closest('.sweet-shop__nav-frame')) return;
      const frame = document.createElement('div');
      frame.className = 'sweet-shop__nav-frame';
      nav.before(frame);
      frame.append(nav);
      const makeArrow = (direction, label) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sweet-shop__nav-arrow sweet-shop__nav-arrow--' + direction;
        button.setAttribute('aria-label', label);
        if (nav.id) button.setAttribute('aria-controls', nav.id);
        button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (direction === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
        button.addEventListener('click', () => nav.scrollBy({left: (direction === 'prev' ? -1 : 1) * Math.max(160, nav.clientWidth * .65), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}));
        frame.append(button);
        return button;
      };
      const prev = makeArrow('prev', 'Previous categories');
      const next = makeArrow('next', 'More categories');
      const update = () => {
        prev.hidden = nav.scrollLeft <= 2;
        next.hidden = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
      };
      nav.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(nav);
      if (document.fonts) document.fonts.ready.then(update);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
